import React from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { useRouterStore } from "../../../libs/stores";
import "../../css/logout-dialog.css";

interface DialogCloseSessionProps {
  open:        boolean;
  handleClose: () => void;
}

export const DialogCloseSession = ({ open, handleClose }: DialogCloseSessionProps) => {
  const navigate = useNavigate();
  const reset    = useRouterStore((state) => state.reset);

  const [isClosing, setClosing]   = React.useState(false);
  const [isContinuo, setContinuo] = React.useState(false);

  React.useEffect(() => {
    if (isContinuo) handleCloseSession();
  }, [isContinuo]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (!open) { setClosing(false); setContinuo(false); }
  }, [open]);

  // Bloquear scroll del body cuando está abierto
  React.useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const handleCloseSession = () => {
    reset();
    localStorage.removeItem(process.env.REACT_APP_TOKEN!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_OPTIONS!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_ROUTER!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_ROUTER_BACKUP!);
    clearIndexedDB();
    setTimeout(() => {
      navigate("/", { replace: true });
      setClosing(false);
      handleClose();
    }, 2000);
  };

  const handleContinuo = () => {
    setClosing(true);
    setTimeout(() => setContinuo(true), 1000);
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && !isClosing) handleClose();
  };

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="logout-overlay" onClick={handleOverlayClick}>
      <div className="logout-card">

        <div className="logout-header">
          <div className="logout-icon-wrap">
            <span className="logout-icon">⚡</span>
          </div>
          <p className="logout-title">¿Cerrar sesión?</p>
          <p className="logout-subtitle">Esta acción finalizará tu sesión activa</p>
        </div>

        <div className="logout-body">
          <div className="logout-warning">
            <div className="logout-warning-dot" />
            <p className="logout-warning-text">
              Se borrarán los datos locales y serás redirigido al inicio de sesión.
            </p>
          </div>
          {isClosing && (
            <div className="logout-progress-bar">
              <div className="logout-progress-fill" />
            </div>
          )}
        </div>

        <div className="logout-footer">
          <button className="logout-btn-cancel" onClick={handleClose} disabled={isClosing}>
            Cancelar
          </button>
          <button className="logout-btn-confirm" onClick={handleContinuo} disabled={isClosing}>
            {isClosing
              ? <><div className="logout-spinner" /> Saliendo...</>
              : <>→ Confirmar</>
            }
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
};

// ── Limpiar IndexedDB ─────────────────────────────────────────────────────────
const clearIndexedDB = async () => {
  try {
    const dbs = await indexedDB.databases();
    dbs.forEach(({ name }) => {
      if (name) {
        const req     = indexedDB.deleteDatabase(name);
        req.onsuccess = () => console.log(`DB ${name} eliminada`);
        req.onerror   = (e) => console.error(`Error eliminando DB ${name}`, e);
      }
    });
  } catch (e) {
    console.error("Error limpiando IndexedDB", e);
  }
};